import { CheckboxInput } from '@framework/form';
import { RowElement } from '@framework/ui';
import { Space, Tooltip } from 'antd';
import React from 'react';
import { ConfigFormItem } from '../../../../../ui/form/ConfigFormItem';
import { IWidgetComponentProps } from '../../../IWidgetType';
import { getWidgetProps } from '../../inputs/common/util/getWidgetProps';
import { IPaymentRowWidget } from './IPaymentRowWidget';
import { PaymentRowFieldPreview } from './components/PaymentRowFieldPreview';
import { PaymentRowReportField } from './components/PaymentRowReportField';
import { PaymentRowWidgetContainer } from './components/PaymentRowWidgetContainer';

export interface IPaymentRowWidgetPreviewComponentProps
  extends IWidgetComponentProps<IPaymentRowWidget> {}

export function PaymentRowWidgetPreviewComponent(
  props: IPaymentRowWidgetPreviewComponentProps,
) {
  const { widget } = props;
  const options = getWidgetProps(props);

  return (
    <PaymentRowWidgetContainer
      included
      canBeExcluded={widget.canBeExcluded}
      left={
        <Tooltip title="Includi nel pagamento">
          <ConfigFormItem name={`${options.name}@included`}>
            <CheckboxInput name={`${options.name}@included`} />
          </ConfigFormItem>
        </Tooltip>
      }
      report={
        widget.showReport && (
          <Space size={0} wrap>
            <PaymentRowReportField
              readonly={true}
              name={options.name}
              label={'Importo Unitario'}
              value={null}
            />
            <PaymentRowReportField
              readonly={true}
              name={options.name}
              label={'Imponibile'}
              value={null}
            />
            <PaymentRowReportField
              readonly={true}
              name={options.name}
              label={'IVA'}
              value={null}
            />
            <PaymentRowReportField
              readonly={true}
              name={options.name}
              label={'Totale'}
              value={null}
            />
          </Space>
        )
      }
    >
      <PaymentRowFieldPreview
        config={widget.description}
        options={options}
        label={'Descrizione'}
      />
      <RowElement>
        <PaymentRowReportField
          readonly={true}
          name={options.name}
          label={'Importo Listino'}
          value={null}
        />
        <PaymentRowFieldPreview
          config={widget.quantity}
          options={options}
          label={'Quantità'}
        />
        <PaymentRowFieldPreview
          config={widget.unit}
          options={options}
          label={'Unità di Misura'}
        />
        <PaymentRowFieldPreview
          config={widget.vat}
          options={options}
          label={'IVA'}
        />
        <PaymentRowFieldPreview
          config={widget.discount}
          options={options}
          label={'Sconto/Esenzione'}
        />
      </RowElement>
      <Space>
        {/* {widget.canBeExcluded && (
          <Tooltip title="Includi nel pagamento">
            <ConfigFormItem name={`${options.name}@included`}>
              <CheckboxInput name={`${options.name}@included`} />
            </ConfigFormItem>
          </Tooltip>
        )} */}
        {/* {widget.showReport && (
          <Space size={0}>
            <PaymentRowReportField
              readonly={true}
              name={options.name}
              label={'Imponibile'}
              value={null}
            />
            <PaymentRowReportField
              readonly={true}
              name={options.name}
              label={'IVA'}
              value={null}
            />
            <PaymentRowReportField
              readonly={true}
              name={options.name}
              label={'Totale'}
              value={null}
            />
          </Space>
        )} */}
      </Space>
    </PaymentRowWidgetContainer>
  );
}
